<template>
  <MainBody></MainBody>
</template>

<script>
import { mapGetters } from "vuex";
import MainBody from "./main/MainBody";

import { assetsURL } from "@/utils";

export default {
  name: "user-main",
  components: {
    MainBody,
  },
  metaInfo() {
    return {
      title: "건강기능식품&수입식품 온라인 위생교육기관",
      meta: [{ name: "description", content: "위생교육, 수입식품교육, 수입식품위생교육,  GMP교육, 건강기능식품법, 건강기능식품, 건강기능식품 판매, 법정교육, 수입식품안전관리 특별법, 건강기능식품협회, 수입식품협회, 전문제조업, 벤처제조업, 품질관리인, 한국건강기능식품협회, 건강기능식품 수입식품 온라인 위생교육기관" }],
    };
  },
  data() {
    return {
      enrlNo: this.$route.query.enrlNo,
      userMap: {},
      assetsURL: assetsURL,
    };
  },
  watch: {
    $route: function (to, from) {},
  },
  created() {},
  methods: {
    getCntntsView: function () {
      this.$router.push(`/user/cntnts/${this.$route.query.cntntsNo}`);
    },
  },
  computed: {
    ...mapGetters(["routeParams", "currentUser"]),
  },
};
</script>
